module.exports = __webpack_public_path__ + "assets/img/Type BS (11).bfab5752.jpg";